export default "__VITE_ASSET__DKK_ysnC__"